<template>
  <div class="wrap">
      <div id="mapBox"></div>
  </div>
</template>

<script>
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
export default {
 data(){
     return{
          mapBox:'',
          markersList:[],
          allStation:[],
          currentStation:{},
          latLng:{}
     } 
 },
 mounted(){
   this.latLng = getLocalStorage('LatLng')
   this.allStation =  this.$route.params.allStation || this.$session.getSession('allStation')
   this.currentStation =  this.$route.params.currentStation || this.$session.getSession('currentStation')//当前站点
   this.initMap()
 },
 methods:{
      initMap() {
            this.mapBox = new AMap.Map('mapBox', {
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom:15, //初始化地图层级
                viewMode: '2D',  //设置地图模式
                lang:'zh_cn',  //设置地图语言类型
            });
            this.myMarker()
            this.nearStation()
           
      },
     //
     myMarker(){
        let iconSelf = new AMap.Icon({
                size: new AMap.Size(30,30),
                image: require('../../assets/image/stationMarker.png'),
                imageSize: new AMap.Size(30,30) 
         });
         //我的位置
        let  marker = new AMap.Marker({
                position: [this.latLng.lng,this.latLng.lat],
                map: this.mapBox,
                icon: iconSelf,
                clickable :false,
          });
     },
          //根据经纬度来查询附近的站点
     nearStation(){
            let currentMarker = ''
            this.markersList = []
            let iconSelf = new AMap.Icon({
                size: new AMap.Size(18,18),
                image: require('../../assets/image/stationMarker.png'),
                imageSize: new AMap.Size(18,18) 
            });
            for (var i = 0, marker; i < this.allStation.length; i++) {
                var marker = new AMap.Marker({
                    position: [this.allStation[i].longitude ,this.allStation[i].latitude],//不同标记点的经纬度
                    map: this.mapBox,
                    icon: iconSelf,
                    clickable : true,
                  });
                  marker.setLabel({
                    content:`<div class='info'>${this.allStation[i].stationName}</div>`, //设置文本标注内容
                    direction: 'top' //设置文本标注方位
                  });
                  marker.stationName = this.allStation[i].stationName;
                  marker.stationId = this.allStation[i].stationId;
                  this.markersList.push(marker);
                  this.mapBox.add(this.markersList)
                   AMap.event.addListener(marker, 'click', (e)=> {
                    this.markersList.forEach(item=>{
                        if(item.stationId == e.target.stationId){
                            this.clickMarker(item)
                            
                        }
                    })
            
                  }) 
              }
             //把当前的位置
              currentMarker = this.markersList.filter(item=>{
                 return  this.currentStation.stationId ==item.stationId
              })[0]
               this.mapBox.setFitView(currentMarker);
               this.walkingLine()
               this.changeStyle(currentMarker)
        
     },
     //线路规划
     walkingLine(){
       var walkingOption = {} 
       var walking = new AMap.Walking(walkingOption)
       //根据起终点坐标规划步行路线
       let start =[this.latLng.lng,this.latLng.lat]
       let end =[this.currentStation.longitude,this.currentStation.latitude]
        walking.search(start,end,(status, result)=>{
         if (status === 'complete') {
            if (result.routes && result.routes.length) {
                 this.drawRoute(result.routes[0])
             }
          }else{
             
          } 
       });
     },
      drawRoute (route) {
        var path = this.parseRouteToPath(route)
        var routeLine = new AMap.Polyline({
            path: path,
            isOutline: true,
            outlineColor: '#ffeeee',
            borderWeight: 2,
            strokeWeight: 5,
            strokeColor: '#22B2ED',
            lineJoin: 'round'
        })
        routeLine.setMap(this.mapBox)
        //调整视野达到最佳显示区域
        // this.mapBox.setFitView([ startMarker, endMarker, routeLine ])
    },
    parseRouteToPath(route) {
      var path = []
      for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i]
          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j])
          }
      }
      return path
    },
     //点击站点
     clickMarker(current){
       this.mapBox.clearMap()
       this.currentStation = this.allStation.filter(item=>{
        return item.stationId == current.stationId
       })[0]
    //    let stationSaneName = this.currentStation.stationName
    //     this.sameStationList  = this.allStation.filter(item=>{
    //         return item.stationName == stationSaneName
    //      })
    //     this.sameStationLength = this.sameStationList.length
       this.myMarker()
       this.nearStation()
     
     },
     //点击站点,更改样式
     changeStyle(current){
       this.markersList.forEach(item=>{
          item.setLabel({
                content:`<div class='info'>${item.stationName}</div>`, //设置文本标注内容
                direction: 'top' //设置文本标注方位
            });
       })
        current.setLabel({
                content:`<div class='infoActive'>${current.stationName}</div>`, //设置文本标注内容
                direction: 'top' //设置文本标注方位
        });
     },
 }
}
</script>

<style lang="scss" scoped>
   .wrap{
        width: 100%;
        height: 100vh;
        position: relative;
        overflow: hidden;
        #mapBox{
         width: 100%;
         height: 100vh;
         position: absolute;
        }
   }
   ::v-deep{
   .amap-marker-label{
     border-radius:4px;
     padding:0px;
     font-size:12px;
     border:1px solid #22B2ED;
    .info{
       color:#22B2ED!important;
       padding:3px 6px;
     }
    .infoActive{
      color:#fff!important;
      background-color:#22B2ED ;
      padding:3px 6px;
      border:1px solid #22B2ED
      
    }
   }
  }
</style>